import { Box, Typography } from '@mui/material';
import { SurveyV2, UserDto } from '@act/shared/data-transfer-objects';
import { applyMustacheTemplate } from '@act/shared/utilities';

export interface SurveyTitleSectionProps {
  survey: SurveyV2.SurveyDto;
  member: UserDto;
}

const SurveyTitleSection = ({ survey, member }: SurveyTitleSectionProps) => {
  // Early return if no member data
  if (!member) {
    return (
      survey?.displayName && (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '8px',
            padding: '8px 0 16px',
          }}
        >
          <Typography display="block" variant="headlineMedium">
            {survey.displayName || ''}
          </Typography>
          <Typography variant="bodyLarge">{survey.summary || ''}</Typography>
        </Box>
      )
    );
  }

  return (
    (survey?.displayName || survey?.summary) && (
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '8px',
          padding: '8px 0 16px',
        }}
      >
        <Typography display="block" variant="headlineMedium">
          {survey.displayName || ''}
        </Typography>
        <Typography variant="bodyLarge">
          {survey.summary
            ? applyMustacheTemplate(survey.summary, {
                memberName: `${member?.firstName}`,
              })
            : ''}
        </Typography>
      </Box>
    )
  );
};

export default SurveyTitleSection;
